import {WaitfreeTicketDto} from '../../common/shared/api/gateway/WaitfreeTicketDto.interface';
import {WaitfreeTicket} from '../generated/types';

export function createWaitfreeTicket({
  charged_count,
  charged_at,
  charged_period,
}: WaitfreeTicketDto): WaitfreeTicket {
  return {
    chargedCount: charged_count,
    chargedAt: charged_at,
    chargedPeriod: charged_period,
  };
}
